import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../../api';

/**
 * A 409 on a member (last admin, managed by the directory, role set by a group mapping) means the
 * row the admin acted on was stale: the directory or another admin changed the workspace meanwhile.
 * Refreshes the workspace's members so the row shows what the API holds.
 */
export const refreshMembersOnConflict = (
  queryClient: QueryClient,
  error: ApiError | null | undefined,
  organizationId: string,
) => {
  if (error?.httpCode !== 409) return;
  queryClient.invalidateQueries({ queryKey: ['organization-members', organizationId] });
  queryClient.invalidateQueries({ queryKey: ['organization-member', organizationId] });
};
